import { User } from 'entities/user';
import { simpleClient } from 'services/apiGatewayClient';
import { State } from 'store';
import { createService } from '../genericAPIGatewayService';
import { customGetSaga, Service } from './usersService';

export { Service };

export const { Actions, Selectors } = createService<User, Service.Users>({
  service: Service.Users,
  stateConverter: (state: State) => state.data.users,
  client: undefined,
  endpointCreator: undefined,
  sagas: [],
});

const client = simpleClient<User>();
export const Sagas = [customGetSaga(client, Actions, Selectors)];
